import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../../utils/common'
import LinkWithStatus from '../../../common/LinkWithStatus'
import { deleteRequest, getRequest } from '../../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import Pagination from '../../../common/Pagination'
import Tooltip from '../../../common/tooltip'
import NoRecordsFound from '../../../common/NoRecordsFound'
import { createSearchParams } from 'react-router-dom'
import SubSystemEditCreateForm from './form'
import { getSessionStorageData } from '../../../../utils/SessionStorage'

const SubSystemRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="w-2/12 pl-10">
          {formatEmptyValue(props.sub_system_id)}
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props.name}>
            <div>{props.name}</div>
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6">
          {formatEmptyValue(props.system_data.system_id)}
        </div>
        <div className="w-2/12 pl-6 table_text">
          <Tooltip message={props.system_data.name}>
            <div>{props.system_data.name}</div>
          </Tooltip>
        </div>

        <div className="w-2/12 pl-6">
          {formatEmptyValue(props.system_data.make)}
        </div>

        <div className="flex w-2/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const SubSystem = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const [subSystemListData, setSubSystemListData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [selectedSubSystem, setSelectedSubSystem] = useState({})
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const currentUrl = useRef(`/api/sub_system/?search=${searchValue}`)

  useEffect(() => {
    getSubSystemList()
    dispatch({
      type: 'header',
      data: {
        header: 'Sub System',
        sub_header: 'Can be configure sub system data from here',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getSubSystemList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Sub System`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    setSubSystemListData(response.results)
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteSubSystem = async (sub_system) => {
    if (
      window.confirm(
        `Are you sure you want to Delete ${sub_system.name} Sub System`
      )
    ) {
      let res = await deleteRequest(`/api/sub_system/${sub_system.id}/`)
      getSubSystemList()
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `System Deleted Successfully`,
        },
      })
    }
  }

  return (
    <>
      <SubSystemEditCreateForm
        showModal={showModal}
        setShowModal={setShowModal}
        getSubSystemList={getSubSystemList}
        selectedSubSystem={selectedSubSystem}
        onSave={() => {
          getSubSystemList()
          setShowModal(false)
        }}
        onClose={() => {
          setSelectedSubSystem({})
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getSubSystemList()
        }}
      >
        <div className="flex space-x-5">
          <div className="w-1/3">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
              placeholder="Enter to search"
              type="search"
              name="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value)
                currentUrl.current = `/api/sub_system/?search=${e.target.value}`
              }}
            />
          </div>
          <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
            Search
          </button>

          <div className="w-2/3 font-light text-right space-x-5">
            <LinkWithStatus
              href={`/administration/sub_system/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Sub System"
              onClickFunc={() => {
                setSelectedSubSystem({})
                setShowModal(true)
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Sub System Id</div>
          <div className="flex w-2/12 pl-6 items-center">Name</div>
          <div className="flex w-2/12 pl-6 items-center">System Id</div>
          <div className="flex w-2/12 pl-6 items-center">System Name</div>
          <div className="w-2/12 pl-6">Make Details</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {subSystemListData?.map((system, index) => {
        return (
          <SubSystemRow
            {...system}
            key={`system-${index}`}
            onEdit={() => {
              setSelectedSubSystem(system)
              setShowModal(true)
            }}
            onDelete={() => {
              deleteSubSystem(system)
            }}
          />
        )
      })}

      {subSystemListData?.length < 1 && (
        <NoRecordsFound caption={"System's Not Found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getSubSystemList(e)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getSubSystemList(e)
          }}
        />
      </div>
    </>
  )
}

export default SubSystem
